import React from 'react'
import {Input} from 'reactstrap'


export default class SelectPassengers extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            passengers: this.props.passengers || 1
        }
    }


    getSelection = () => {
        return this.state.passengers
    }

    renderPassenger = (h) => {
        return (
            <option key={h} value={h}>{h}</option>
        )
    }

    renderPassengers = () => {
        let result = []
        for (let i = 1; i <= 16; i++) {
            result = result.concat(this.renderPassenger(i))
        }
        return result
    }
    updateHours = (selected) => {
        this.setState(selected)
    }

    render() {
        return (
            <div>
                <Input type="select" name="passengers" id="passengers"
                       defaultValue={this.state.passengers}
                       onChange={(selected) => {
                           this.updateHours({passengers: selected.currentTarget.value})
                       }}>
                    {this.renderPassengers()}
                </Input>
            </div>
        )
    }
}